import React from 'react';
import sbiLogo from '../../assets/images/banks/sbi.png';
import hdfcLogo from '../../assets/images/banks/hdfc.png';
import axisLogo from '../../assets/images/banks/axis.png';
import iciciLogo from '../../assets/images/banks/IBN.png';
import kotakLogo from '../../assets/images/banks/Kotak.png';
import bobLogo from '../../assets/images/banks/bankofbaroda.png';
import boiLogo from '../../assets/images/banks/bankOfIndia.png';
import canaraLogo from '../../assets/images/banks/CanaraBAnk.png';
import pnbLogo from '../../assets/images/banks/punjabNationalBank.png';
import federalLogo from '../../assets/images/banks/fedralBank.png';
import yesBankLogo from '../../assets/images/banks/Yesbank.png';

const DSADisclosure = () => {
  // Bank data with actual logo images
  const banks = [
    { name: 'SBI', logo: sbiLogo, color: '#1E88E5' },
    { name: 'HDFC Bank', logo: hdfcLogo, color: '#FF6B35' },
    { name: 'Axis Bank', logo: axisLogo, color: '#9C27B0' },
    { name: 'ICICI Bank', logo: iciciLogo, color: '#FF9800' },
    { name: 'Kotak Mahindra', logo: kotakLogo, color: '#E91E63' },
    { name: 'Bank of Baroda', logo: bobLogo, color: '#00BCD4' },
    { name: 'Bank of India', logo: boiLogo, color: '#3F51B5' },
    { name: 'Canara Bank', logo: canaraLogo, color: '#009688' },
    { name: 'Punjab National Bank', logo: pnbLogo, color: '#795548' },
    { name: 'Federal Bank', logo: federalLogo, color: '#F44336' },
    { name: 'Yes Bank', logo: yesBankLogo, color: '#607D8B' },
    { name: 'More..', logo: null, color: '#9E9E9E' },
  ];

  return (
    <section id="about" className="py-8 bg-gradient-to-r from-blue-50 via-indigo-50 to-blue-100 border-y-2 border-blue-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
        {/* DSA Disclosure Card */}
        <div className="bg-gradient-to-br from-white via-blue-50 to-indigo-50 rounded-2xl shadow-2xl border-2 border-blue-400 overflow-hidden mb-8">
          {/* Header Section with Gradient */}
          <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-700 px-6 md:px-8 py-5">
            <div className="flex items-center gap-4">
              <div className="bg-white/20 backdrop-blur-sm rounded-full p-3 flex-shrink-0">
                <svg className="w-6 h-6 md:w-7 md:h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-white">
                  Authorised Direct Selling Agent (DSA)
                </h3>
                <p className="text-blue-100 text-sm mt-1">
                  RBI-Regulated Channel Partner
                </p>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="p-6 md:p-8">
            <div className="space-y-4">
              {/* Main Disclosure */}
              <div className="bg-white rounded-xl p-5 md:p-6 border-l-4 border-indigo-500 shadow-md">
                <p className="text-gray-800 leading-relaxed" style={{ fontSize: '15px' }}>
                  <strong className="text-indigo-700 text-base">Prajwal Jadhav and Nikita Bansod / Shravi Finance</strong>
                  <span className="text-gray-600"> (Individual DSA)</span> is an authorised Direct Selling Agent (DSA) / Channel Partner for RBI-regulated banks and NBFCs.
                </p>
              </div>

              {/* Important Notice Box */}
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-5 border-2 border-blue-200 shadow-sm">
                <div className="flex items-start gap-3">
                  <div className="bg-blue-500 rounded-lg p-2 flex-shrink-0 mt-0.5">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-800 font-semibold mb-1" style={{ fontSize: '15px' }}>
                      Important Notice
                    </p>
                    <p className="text-gray-700 leading-relaxed" style={{ fontSize: '14px' }}>
                      We only assist in connecting customers with lenders. We do not provide loans directly. All loans are sanctioned exclusively by RBI-regulated partner banks and NBFCs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      
      {/* Partner Lenders Animated Ticker - Full Width */}
      <div className="overflow-hidden w-full">
          <div className="px-6 py-4">
            <h4 className="text-lg md:text-xl font-bold text-gray-800 text-center">
              Partner Lenders (RBI-Regulated Banks & NBFCs)
            </h4>
          </div>
          
          {/* Animated Ticker Container - Full Width */}
          <div className="relative overflow-hidden py-4 sm:py-5 md:py-6 w-full">
            {/* Gradient Overlays for fade effect */}
            <div className="absolute left-0 top-0 bottom-0 w-12 sm:w-16 md:w-24 bg-gradient-to-r from-gray-50 via-gray-50 to-transparent z-10 pointer-events-none"></div>
            <div className="absolute right-0 top-0 bottom-0 w-12 sm:w-16 md:w-24 bg-gradient-to-l from-gray-50 via-gray-50 to-transparent z-10 pointer-events-none"></div>
            
            {/* Ticker Wrapper */}
            <div className="flex animate-scroll">
              {/* First Set */}
              <div className="flex items-center gap-2 sm:gap-4 md:gap-6 px-4 sm:px-6 md:px-10 flex-shrink-0">
                {banks.map((bank, index) => (
                  <div 
                    key={`first-${index}`} 
                    className="flex items-center gap-1.5 sm:gap-2 md:gap-3 whitespace-nowrap group bg-white rounded-md md:rounded-lg px-2 sm:px-3 md:px-4 py-2 sm:py-2.5 md:py-3 shadow-sm border border-gray-200 group-hover:border-indigo-400 group-hover:shadow-md transition-all"
                  >
                    {/* Logo Container */}
                    {bank.logo ? (
                      <img 
                        src={bank.logo} 
                        alt={bank.name}
                        className="h-5 w-auto sm:h-6 md:h-8 object-contain flex-shrink-0"
                        loading="lazy"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    ) : (
                      <div 
                        className="bg-gray-100 rounded-md md:rounded-lg p-1 sm:p-1.5 md:p-2 flex items-center justify-center flex-shrink-0"
                      >
                        <div 
                          className="text-xs sm:text-sm md:text-lg font-bold"
                          style={{ color: bank.color }}
                        >
                          {bank.name.charAt(0)}
                        </div>
                      </div>
                    )}
                    {/* Bank Name */}
                    <span className="text-xs sm:text-sm font-semibold text-gray-800 group-hover:text-indigo-600 transition-colors">
                      {bank.name}
                    </span>
                  </div>
                ))}
              </div>
              
              {/* Duplicate Set for seamless loop */}
              <div className="flex items-center gap-2 sm:gap-4 md:gap-6 px-4 sm:px-6 md:px-10 flex-shrink-0">
                {banks.map((bank, index) => (
                  <div 
                    key={`second-${index}`} 
                    className="flex items-center gap-1.5 sm:gap-2 md:gap-3 whitespace-nowrap group bg-white rounded-md md:rounded-lg px-2 sm:px-3 md:px-4 py-2 sm:py-2.5 md:py-3 shadow-sm border border-gray-200 group-hover:border-indigo-400 group-hover:shadow-md transition-all"
                  >
                    {/* Logo Container */}
                    {bank.logo ? (
                      <img 
                        src={bank.logo} 
                        alt={bank.name}
                        className="h-5 w-auto sm:h-6 md:h-8 object-contain flex-shrink-0"
                        loading="lazy"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    ) : (
                      <div 
                        className="bg-gray-100 rounded-md md:rounded-lg p-1 sm:p-1.5 md:p-2 flex items-center justify-center flex-shrink-0"
                      >
                        <div 
                          className="text-xs sm:text-sm md:text-lg font-bold"
                          style={{ color: bank.color }}
                        >
                          {bank.name.charAt(0)}
                        </div>
                      </div>
                    )}
                    {/* Bank Name */}
                    <span className="text-xs sm:text-sm font-semibold text-gray-800 group-hover:text-indigo-600 transition-colors">
                      {bank.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <div className="bg-gray-50 px-6 py-3 border-t border-gray-200">
            <p className="text-center text-gray-600 text-xs" style={{ fontSize: '12px' }}>
              *Partner lenders may vary. All lenders are RBI-regulated banks and NBFCs.
            </p>
          </div>
        </div>
    </section>
  );
};

export default DSADisclosure;

